import { Skeleton } from "antd";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { CompetitorTypes } from "~enums/competitorTypes";
import { useGetFixture } from "~pages/Fixtures/hooks";
import type { FixtureEntrantTransformed } from "~pages/Fixtures/types";

const StyledTitleSkeleton = styled(Skeleton.Input)`
  && {
    display: inline;
  }

  & > .ant-skeleton-input.ant-skeleton-input {
    margin-top: 8px;
    height: 30px;
    width: 250px;
  }
`;
StyledTitleSkeleton.displayName = "StyledTitleSkeleton";

export const useEditFixturePageTitle = () => {
  const { formatMessage } = useIntl();
  const { data: fixtureData, isLoading } = useGetFixture();

  if (isLoading) {
    return { title: <StyledTitleSkeleton active />, tabTitle: undefined };
  }

  const isCompetitors = fixtureData?.competitorType === CompetitorTypes.Entity;
  const isParticipants = fixtureData?.competitorType === CompetitorTypes.Person;

  if (!isCompetitors && !isParticipants) {
    const nonEntrantsTitle = formatMessage({
      id: "pageTitles.advancedFixtureEdit.fixtureOnly",
    });
    return { title: nonEntrantsTitle, tabTitle: nonEntrantsTitle };
  }

  const entrants =
    fixtureData.competitorType === CompetitorTypes.Person ? fixtureData.formData.participants : fixtureData.formData.competitors;

  const notSpecifiedText = formatMessage({ id: "not.specified" });
  const getName = (entrants: FixtureEntrantTransformed[]) => {
    const names = (entrants || []).map((x) => x.name).filter(Boolean);
    return names.length > 0 ? names.join(" / ") : notSpecifiedText;
  };

  const homeName = getName(entrants.filter((x) => x.isHome));
  const awayName = getName(entrants.filter((x) => !x.isHome));

  const title = formatMessage({ id: "pageTitles.advancedFixtureEdit" }, { homeName, awayName });

  return {
    title,
    tabTitle: title,
  };
};
